import type { ReactNode } from 'react';

export function SectionHead({ children, right }: { children: ReactNode; right?: ReactNode }) {
  return (
    <div className="flex items-baseline justify-between mb-4 pb-2 border-b border-stone-800">
      <h2 className="text-[11px] uppercase tracking-[0.25em] text-stone-400 font-mono">{children}</h2>
      {right}
    </div>
  );
}
